import moment from 'moment-timezone';

export function formatAppointmentTimeForDisplay(
    appointmentTimeString,
    appointmentLocationTimeZone
) {
    if (appointmentTimeString) {
        return moment
            .tz(appointmentTimeString, appointmentLocationTimeZone)
            .format('ddd, MMM D - h:mm a z');
    }
}

export function formatAppointmentTimeTodayTomorrow(
    appointmentTimeString,
    appointmentLocationTimeZone
) {
    const today = moment().endOf('day');
    const tomorrow = moment()
        .endOf('day')
        .add(1, 'days');

    const appointmentTime = moment.tz(
        appointmentTimeString,
        appointmentLocationTimeZone
    );

    if (appointmentTime < today) {
        return appointmentTime.format('[Today], MMM D - h:mm a z');
    } else if (appointmentTime < tomorrow) {
        return appointmentTime.format('[Tomorrow], MMM D - h:mm a z');
    } else {
        return moment
            .tz(appointmentTimeString, appointmentLocationTimeZone)
            .format('ddd, MMM D - h:mm a z');
    }
}

export function formatAppointmentDetailsTime(
    appointmentTimeString,
    appointmentLocationTimeZone
) {
    if (appointmentTimeString) {
        return moment
            .tz(appointmentTimeString, appointmentLocationTimeZone)
            .format('h:mma z');
    }
}

export function formatAppointmentDetailsDate(
    appointmentTimeString,
    appointmentLocationTimeZone
) {
    if (appointmentTimeString) {
        return moment
            .tz(appointmentTimeString, appointmentLocationTimeZone)
            .format('MMMM Do');
    }
}

export function formatAppointmentDateAndTime(
    appointmentTimeString,
    appointmentLocationTimeZone
) {
    if (appointmentTimeString) {
        return {
            date: moment
                .tz(appointmentTimeString, appointmentLocationTimeZone)
                .format('dddd, MMM D'),
            time: moment
                .tz(appointmentTimeString, appointmentLocationTimeZone)
                .format('h:mma z'),
        };
    } else {
        return {};
    }
}
